import {
  BillingPeriod,
  IAccountInventoryPage,
  PaymentProviderTypeEnum,
  LootboxType,
  LootboxSource,
  LootboxStatus,
  GrantLootboxRequest,
} from "domains/accounts/store/types"
import { Account } from "domains/accounts/store/account.store"
import { apiCall } from "api-calls/api-call"

export const getAccounts = async(
  filter: string,
  page: number,
  limit: number,
): Promise<{
  data: Account[];
  total: number;
}> => {
  const query: { page: number; limit: number; filter?: string } = {
    page,
    limit,
  }

  if (filter) query.filter = filter

  return apiCall({
    method: "GET",
    path: "accounts",
    query,
  })
}

export const getAccountDetailsById = async(id: string) => {
  return apiCall({
    method: "GET",
    path: `accounts/${id}`,
  })
}

export const getGameAccountDetailsById = async(id: string) => {
  return apiCall({
    method: "GET",
    path: `accounts/${id}`,
  })
}

export const givePremiumFunc = async(
  data: {
    subscriptionId: string;
    billingPeriod: BillingPeriod;

    startDate: string;
    paymentProviderType: PaymentProviderTypeEnum;
    billingPlanId: string;
  },
  id: string,
) => {
  return apiCall({
    method: "POST",
    path: `accounts/give-premium/${id}`,
    body: data,
  })
}

export const removePremiumFunc = async(data: { accountSubscriptionId: string }) => {
  return apiCall({
    method: "POST",
    path: "accounts/remove-premium",
    body: data,
  })
}

export const freezeAccountFunc = async(id: string, data: { reasonOfBan: string }) => {
  return apiCall({
    method: "POST",
    path: `accounts/freeze-account/${id}`,
    body: data,
  })
}

export const unfreezeAccountFunc = async(id: string) => {
  return apiCall({
    method: "POST",
    path: `accounts/unfreeze-account/${id}`,
  })
}

export const verifyEmailFunc = async(id: string) => {
  return apiCall({
    method: "POST",
    path: `accounts/verify-email/${id}`,
  })
}

export const clearBalanceFunc = async(id: string) => {
  return apiCall({
    method: "POST",
    path: `accounts/clear-balance/${id}`,
  })
}

export const obfuscateAccount = async(id: string) => {
  return apiCall({
    method: "POST",
    path: `accounts/obfuscate/${id}`,
  })
}

export const addBonusFunc = async(
  data: { name: string; amount: number; type: number },
  id: string,
) => {
  return apiCall({
    method: "POST",
    path: "transactions",
    body: { ...data, accountId: id },
  })
}

export const changeCountryFunc = async(id: string, country: string) => {
  return apiCall({
    method: "POST",
    path: `accounts/change-country/${id}`,
    body: { country },
  })
}

export const setGameplayBoostTesterFunc = async(id: string, enabled: boolean) => {
  return apiCall({
    method: "POST",
    path: `accounts/gameplay-boost-tester/${id}`,
    body: { enabled },
  })
}

export const getInventory = async(
  id: string,
  page: number,
  limit: number,
): Promise<IAccountInventoryPage> => {
  const query: { page: number; limit: number; } = {
    page,
    limit,
  }

  return apiCall({
    method: "GET",
    path: `accounts/${id}/inventory`,
    query,
  })
}

export const getLootboxHistory = async(
  profileId: string,
  query?: {
    type?: LootboxType
    source?: LootboxSource
    status?: LootboxStatus
    obtainedAfter?: string
    obtainedBefore?: string
    skip?: number
    take?: number
  },
): Promise<{ data: any[]; total: number }> => {
  const queryParams: any = {}
  if (query?.type) queryParams.type = query.type
  if (query?.source) queryParams.source = query.source
  if (query?.status) queryParams.status = query.status
  if (query?.obtainedAfter) queryParams.obtainedAfter = query.obtainedAfter
  if (query?.obtainedBefore) queryParams.obtainedBefore = query.obtainedBefore
  if (query?.skip !== undefined) queryParams.skip = query.skip
  if (query?.take !== undefined) queryParams.take = query.take

  return apiCall({
    method: "GET",
    path: `avatar/lootbox/${profileId}/lootbox-history`,
    query: queryParams,
  })
}

export const grantLootboxesFunc = async(
  profileId: string,
  data: GrantLootboxRequest,
) => {
  return apiCall({
    method: "POST",
    path: `avatar/lootbox/${profileId}/grant-lootboxes`,
    body: data,
  })
}

export const revokeLootboxesFunc = async(
  profileId: string,
  data: { ids: number[] },
) => {
  return apiCall({
    method: "POST",
    path: `avatar/lootbox/${profileId}/revoke-lootboxes`,
    body: data,
  })
}

export const getBattlePassHistory = async(
  profileId: string,
  query?: {
    status?: string
    season?: number
    startsAfter?: string
    endsBefore?: string
    skip?: number
    take?: number
  },
): Promise<{ data: any[]; total: number }> => {
  const queryParams: any = {}
  if (query?.status) queryParams.status = query.status
  if (query?.season !== undefined) queryParams.season = query.season
  if (query?.startsAfter) queryParams.startsAfter = query.startsAfter
  if (query?.endsBefore) queryParams.endsBefore = query.endsBefore
  if (query?.skip !== undefined) queryParams.skip = query.skip
  if (query?.take !== undefined) queryParams.take = query.take

  return apiCall({
    method: "GET",
    path: `avatar/battle-pass/${profileId}/battle-pass-history`,
    query: queryParams,
  })
}

export const grantBattlePassFunc = async(profileId: string) => {
  return apiCall({
    method: "POST",
    path: `avatar/battle-pass/${profileId}/grant-battle-pass`,
  })
}

export const revokeBattlePassFunc = async(profileId: string) => {
  return apiCall({
    method: "POST",
    path: `avatar/battle-pass/${profileId}/revoke-battle-pass`,
  })
}
